module.exports = __webpack_public_path__ + "static/village_card_img9@2x-b21fd0c842de9343d50d021caa924e38.png";